import React from 'react';
import { getLangFromPath } from '../utils/langPath';

const COPY = {
  uk: { title: 'Щось пішло не так', action: 'Оновити сторінку' },
  ru: { title: 'Что-то пошло не так', action: 'Обновить страницу' },
};

// Keeps a crash in one page from blanking the whole app
class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Page crashed:', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const copy = COPY[getLangFromPath(window.location.pathname)] || COPY.uk;
    return (
      <main className="min-h-screen flex flex-col items-center justify-center gap-4 px-4 text-center">
        <h1 className="text-2xl font-bold text-black m-0">{copy.title}</h1>
        <button
          onClick={() => window.location.reload()}
          className="px-6 py-3 bg-dewalt border-none rounded-lg text-sm font-semibold cursor-pointer"
        >
          {copy.action}
        </button>
      </main>
    );
  }
}

export default ErrorBoundary;
